/**
 * Procedure Categories and Procedures for MD in Radiotherapy / Radiation Oncology students
 * Extracted with strict evidence from official NMC PDF
 */
export const RADIOTHERAPY_MD_PROCEDURES = {
  "Radiotherapy Planning, Simulation & Execution": [
    "Patient Positioning, Fixed/Extended SSD Setup & Laser Alignment",
    "Temporary and Permanent Field Marking (Tattoo / Gentian Violet)",
    "Thermoplastic Beam Direction Shell Construction & Head/Body Immobilisation",
    "Target Volume Determination & Outline Techniques (Manual & CT Derived)",
    "Treatment Planning (Single Field, Opposed Pair, Wedges, 3D-CRT, IMRT, IGRT, Tomotherapy)",
    "Tissue Compensation (Bolus, Wedges) & Lead Shielding / Eye Shield Insertion",
    "Radiotherapy Prescription Writing & Dose Calculation",
    "Quality Assurance & Portal Imaging Verification",
  ],
  "Brachytherapy & Interventional Procedures": [
    "Manual & After-Loading Insertion / Removal of Radioactive Sources",
    "Brachytherapy Implant Placement (Intracavitary, Interstitial, Surface Mould)",
    "Diagnostic & Palliative Taps (Pleural Effusion Drainage & Ascitic Tap)",
    "Sub-Acute Intestinal Obstruction Management & Nasogastric Feeding",
    "Transcutaneous Electrical Nerve Stimulation (TENS) Analgesia Placement",
  ],
};

export const RADIOTHERAPY_MD_CATEGORIES = Object.keys(RADIOTHERAPY_MD_PROCEDURES);

export const isMDInRadiotherapyDept = (department) => {
  if (!department) {
    try {
      const u = JSON.parse(
        localStorage.getItem("userData") || localStorage.getItem("user") || "{}"
      );
      department = u.department || (u.departments && u.departments[0]);
    } catch (e) {}
  }
  if (!department) return false;
  const d = String(department).toLowerCase();
  return (
    d.includes("radiotherapy") ||
    d.includes("radiation oncology") ||
    d.includes("radiation therapy")
  );
};
